import Clickable from 'components/Common/Clickable'
import AssistChip from 'LuxKit/Chips/AssistChip'
import SolidTimesCircleIcon from 'LuxKit/Icons/solid/SolidTimesCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import { TypographyElement } from 'LuxKit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useOffer from 'hooks/Offers/useOffer'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'

const StyledChip = styled(AssistChip)`
  width: ${rem(160)};
  justify-content: space-between;

  ${mediaQueryUp.tablet} {
    width: unset;
    min-width: ${rem(200)};
    max-width: ${rem(240)};
  }

  & ${TypographyElement} {
    overflow: hidden;
  }
`

const RemoveButton = styled(Clickable)`
  display: flex;
`

interface Props {
  selection: App.OfferComparisonSelection
  onRemove: (selectionId: string) => void
}

function OfferFooterChip({ selection, onRemove }: Props) {
  const [offer] = useOffer(selection.offerId)
  const offerUrl = useOfferUrl(offer, {
    filters: selection.params?.filters,
    searchId: selection.params?.searchId,
    offerLinkIncludesFilters: true,
  })

  const deleteSelection = useCallback<React.MouseEventHandler<HTMLElement>>((e) => {
    e.stopPropagation()
    e.preventDefault()
    onRemove(selection.selectionId)
  }, [onRemove, selection.selectionId])

  return (
    <StyledChip
      key={selection.selectionId}
      variant="filled"
      size="medium"
      to={offerUrl}
      target="_blank"
      disabled={!offerUrl}
      endIcon={<RemoveButton onClick={deleteSelection}>
        <SolidTimesCircleIcon size="S" />
      </RemoveButton>}
    >
      <BodyText variant="medium" wrap="truncate">{selection.name}</BodyText>
    </StyledChip>
  )
}

export default OfferFooterChip
